import GoldcastText from '@/components/core/GoldcastText.vue';
import FilestackS3 from '@/components/core/Filestack/FilestackS3.vue';
import GoldcastModal from '@/commonComponents/Modal.vue';

export default {
  install(app) {
    app.component('GoldcastText', GoldcastText);
    app.component('FilestackS3', FilestackS3);
    app.component('GoldcastModal', GoldcastModal);
  }
};
